import styled, { css } from 'styled-components';
import ds from '../../utils/designSystem';

export const ContainerInput = styled.fieldset`
  border: ${props => (props.error ? '2px' : '1px')} solid ${ds.colors.grayDark};
  border-radius: 4px;
  padding: ${props => props.padding};
  width: ${props => props.width}%;
  position: relative;
  margin-bottom: ${props => props.bottom}px;
  box-sizing: ${props => (props.borderBox ? 'border-box' : 'content-box')};
  border-color: ${props => (props.error ? 'rgba(214, 39, 39, 0.6)' : null)};
`;

ContainerInput.defaultProps = {
  bottom: 0,
  padding: '1.5vh 4.2% 2.5vh'
};

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  margin-top: 15px;
`;

export const Label = styled.legend`
  color: ${props => (props.error ? 'rgba(214, 39, 39, 0.6)' : ds.colors.gray)};
  font-family: 'Lexend Deca', sans-serif;
  font-size: ${ds.fontSizes.regular};
  text-align: left;
`;

export const Input = styled.input`
  border: none;
  font-family: 'Lexend Deca', sans-serif;
  width: 100%;
  margin-right: 2px;
  color: ${ds.colors.grayDark};
  font-weight: 500;
  &:focus {
    outline: none;
  }
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::placeholder {
    font-weight: 500;
    color: ${({ placeholderColor }) => placeholderColor};
  }
  font-size: ${ds.fontSizes.menu};
  background-color: transparent;
  text-align: ${props => (props.right ? 'right' : 'left')};
`;

Input.defaultProps = {
  placeholderColor: ds.colors.gray
};

export const Text = styled.p`
  font-family: 'Lexend Deca', sans-serif;
  font-size: ${props => props.size};
  font-weight: 500;
  ${props =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${props =>
    props.lineHeight &&
    css`
      line-height: ${props.lineHeight};
    `}
  color: ${props => props.color};
`;

Text.defaultProps = {
  size: ds.fontSizes.regular,
  color: ds.colors.manatee
};

export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;
